export default __webpack_public_path__ + "static/media/testimonial1.91ad72a3.png";